export const ShippingAddressExcelHeader = [
  {
    header: "CUSTOMER",
    key: "CUSTOMER",
    width: 25,
  },
  {
    header: "AIRPORT NAME",
    key: "AIRPORT NAME",
  },
  {
    header: "ATTENTION NAME",
    key: "ATTENTION NAME",
  },
  {
    header: "ATTENTION PHONE",
    key: "ATTENTION PHONE",
  },
  {
    header: "CONSIGNEE ADDRESS",
    key: "CONSIGNEE ADDRESS",
  },
  {
    header: "CONSIGNEE NAME",
    key: "CONSIGNEE NAME",
  },
  {
    header: "SHIPPING ADDRESS",
    key: "SHIPPING ADDRESS",
  },
  {
    header: "E-MAIL",
    key: "E-MAIL",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
  {
    header: "UPDATED BY",
    key: "UPDATED BY",
  },
  {
    header: "UPDATED DATE",
    key: "UPDATED DATE",
  },
];

export const ShippingAddressExcelName = "Shipping Address List";
